'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var YEAR = exports.YEAR = 'year';

var DATE = exports.DATE = 'date';

var HOUR = exports.HOUR = 'hour';

var MINUTES = exports.MINUTES = 'minutes';


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-pickers/constants/date-picker-view.js
// module id = 215
// module chunks = 0